import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {
    render() {
        const { changeHandler, saveHandler, Model, ShowModal, CreateHandler, EditHandler, CancelHandler, Mode, errors, ListLokasi } = this.props

        return (
            <div>
                <Modal show={ShowModal} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3">
                            <label for="label" class="form-label" >Label Alamat*</label>
                            <input type="txt" placeholder="contoh: Rumah, Kantor" class="form-control" id="label" value={Model.label} onChange={changeHandler("label")} />
                            <span class="error">{errors["label"]}</span> <br />

                            <label for="nama" class="form-label">Nama Penerima*</label>
                            <input type="txt" class="form-control" id="nama" value={Model.recipent} onChange={changeHandler("recipent")} />
                            <span class="error">{errors["recipent"]}</span> <br />

                            <label for="nomor" class="form-label">Nomor Hp Penerima*</label>
                            <input type="txt" class="form-control" id="nomor" value={Model.recipent_phone_number} onChange={changeHandler("recipent_phone_number")} />
                            <span class="error">{errors["number"]}</span> <br />

                            <div >
                                <label for="lokasi" class="form-label">Kecamatan / Kota*</label>
                                <select id="lokasi" class="form-control btn-outline" value={Model.location_id} onChange={changeHandler("location_id")}>
                                    <option selected hidden>Cari Kecamatan/Kota</option>
                                    {
                                        ListLokasi.map(data => {
                                            return (
                                                <option value={data._id}>{data.lokasi}</option>
                                            )
                                        })
                                    }
                                </select>
                                <span class="error">{errors["lokasi"]}</span> <br />
                            </div>
                            

                            <label for="kode" class="form-label">Kode Pos</label>
                            <input type="txt" class="form-control" id="kode" value={Model.postal_code} onChange={changeHandler("postal_code")} /> <br />


                            <div class="form-floating">
                                <label for="floatingTextarea2">Alamat*</label>
                                <textarea class="form-control" placeholder="Form Isian" id="address" value={Model.address} onChange={changeHandler("address")} style={{height: "100px"}}></textarea>
                            </div>
                            <span class="error">{errors["address"]}</span> <br />
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}